<app-loader *ngIf="isDisabled"></app-loader>
<div class="card border-radius-0 mt-1 p-0">
    <div class="card-header">
        Shift Roster
    </div>
    <div class="card-body p-1">
        <form class="g-3" name="FilterForm" (ngSubmit)="Validate(FilterForm,false)" #FilterForm="ngForm" novalidate>
            <div class="row">
                <div class="col-md-6">
                    <label for="DefaultShift" class="form-label text-label-dark">Employee Type : </label>
                    <div class="btn-group btn-group-toggle">
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='front' name='EMPType'
                                [(ngModel)]="filter.EmpType" (ngModelChange)="onEmpTypeChange('Front')"
                                [ngModelOptions]="{standalone: true}">
                            Front
                        </label>
                        <label class="form-check-label link-dark px-1" ngbButtonLabel>
                            <input class="form-check-input" type="radio" value='back' name='EMPType'
                                [(ngModel)]="filter.EmpType" (ngModelChange)="onEmpTypeChange('Back')"
                                [ngModelOptions]="{standalone: true}">
                            Back
                        </label>
                    </div>
                </div>
            </div>
            <div class="row gx-2 mb-2">
                <div class="col-md-3">
                    <div class="input-group">
                        <input class="form-control" placeholder="dd mm yyyy" name="FromDate"
                            [(ngModel)]="filter.FromDateObj" ngbDatepicker #FromDate="ngbDatepicker"
                            (ngModelChange)="ClearData()" readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="FromDate.toggle()"
                            type="button"></button>
                    </div>
                </div>
                <div class="col-md-3">
                    <div class="input-group">
                        <input class="form-control" placeholder="dd mm yyyy" name="ToDate"
                            [(ngModel)]="filter.ToDateObj" ngbDatepicker #ToDate="ngbDatepicker"
                            (ngModelChange)="ClearData()" readonly />
                        <button class="btn btn-outline-secondary bi bi-calendar3" (click)="ToDate.toggle()"
                            type="button"></button>
                    </div>
                </div>
            </div>
            <div class="row gx-2 mb-2">
                <div class="col-md-3">
                    <label for="BranchName" class="text-label">Branch <span class="mandatory-field" *ngIf="filter.EmpCode == null || filter.EmpCode == ''">*</span></label>
                    <ng-select [items]="Branchs" bindLabel="BranchName" bindValue="BranchMasterID"
                        placeholder="All Branch" [(ngModel)]="filter.BranchId" [virtualScroll]="true"
                        (change)="ESS_RosterFillComboLoad('ClientLoadOnBranchRights')" name="Branchs"
                        [required]="filter.EmpCode == null || filter.EmpCode == ''">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select branch
                    </div>
                </div>
                <div class="col-md-3" *ngIf="filter.EmpType === 'front'">
                    <label for="ClientGroupName" class="text-label" >Client <span
                            class="mandatory-field" *ngIf="filter.EmpCode == null || filter.EmpCode == ''">*</span></label>
                    <ng-select [items]="Clients" bindLabel="ClientGroupName" bindValue="ClientGroupMasterID"
                        placeholder="All Client" [(ngModel)]="filter.ClientId" [virtualScroll]="true"
                        (change)="ESS_RosterFillComboLoad('UserWiseSiteRights')" name="Clients"
                        [required]="filter.EmpCode == null || filter.EmpCode == ''">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select client
                    </div>
                </div>
                <div class="col-md-6" *ngIf="filter.EmpType === 'front'">
                    <label for="Site" class="text-label">Site <span class="mandatory-field" *ngIf="filter.EmpCode == null || filter.EmpCode == ''">*</span></label>
                    <ng-select [items]="Sites" bindLabel="SiteName" bindValue="SiteMasterID" placeholder="All Site"
                        [(ngModel)]="filter.SiteId" [virtualScroll]="true" name="Sites"
                        [required]="filter.EmpCode == null || filter.EmpCode == ''" (change)="ClearData()">
                    </ng-select>
                    <div class="invalid-feedback">
                        Please select site
                    </div>
                </div>

            </div>
            <div class="row gx-2 mb-2">
                <div class="col-md-3 px-1">
                    <label class="form-font-label">Emp Code</label>
                    <input type="text" class="form-control" name="empcode" #empcode="ngModel" placeholder="Emp Code"
                        [(ngModel)]="filter.EmpCode">
                </div>
                <div class="col"></div>
                <div class="col-md-auto gy-2"><br>
                    <button class="btn btn-primary mx-1" [disabled]="isDisabled"><i class="bi bi-funnel me-2"
                            *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Apply':'Loading...'}}
                    </button>

                    <button type="button" class="btn btn-primary mx-1" (click)="Validate(FilterForm,true)"
                        [disabled]="isDisabled"><i class="bi bi-file-earmark-spreadsheet me-2" *ngIf="!isDisabled"></i>
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                            *ngIf="isDisabled"></span>
                        {{!isDisabled?'Excel':'Loading...'}}
                    </button>
                </div>
            </div>
        </form>
        <div class="card mt-2 border-radius-0 p-1">
            <div class="card-body p-0">
                <table class="customeDatatable table table-bordered" style="width: 100%;">
                    <thead class="table-light">
                        <tr>
                            <th scope="col" style="width: 5px;">#</th>
                            <th>Details</th>
                            <th *ngFor="let DisplayColumn of DisplayColumns; let i = index">
                                {{DisplayColumn}} - {{getColDate(i)}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let TableData of Datas; let i = index">
                            <th scope="row" style="width: 5px;">{{i+1}}</th>
                            <td>
                                <div class="row no-gutters cursor-pointer" style="align-items: center;width: 300px;">
                                    <div class="col-9 userdetail">
                                        <span class="text-label">{{TableData['FullName']}}</span><br />
                                        <!-- <span class="text-label-light">#{{TableData['EmpCode']}}</span><br /> -->
                                        <span class="text-label-light">{{TableData['MonthYear']}}</span><br />
                                        <span class="text-label-light">{{TableData['DesignationName']}}</span><br />
                                        <span class="text-label">Branch : {{TableData['BranchName']}}</span><br />
                                        <span class="text-label" *ngIf="filter.EmpType === 'front'">Site :
                                            {{TableData['SiteName']}}</span><br />
                                    </div>
                                </div>
                            </td>
                            <td *ngFor="let DisplayColumn of DisplayColumns; let j = index">
                                <div style="width: 130px;">
                                    <select class="form-select" aria-label="Shift" placeholder="Shift" title="Shift"
                                        name="Shift{{i}}{{j}}" [(ngModel)]="TableData[DisplayColumn]"
                                        #Shift{{i}}{{j}}="ngModel" (change)="setflag(i)">
                                        <option *ngFor="let shift of (TableData['ShiftCode']??'').split(',')"
                                            [value]="shift">
                                            {{shift}}
                                        </option>
                                    </select>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    <div class="card-footer" *ngIf="this.common.PageRight.IsAdd">
        <div class="d-grid gap-2 d-md-flex justify-content-md-end notification-action">
            <label for="file-upload" class="btn btn-primary">
                <i class="bi bi-cloud-upload-fill" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled ? 'Excel Upload' : 'Loading...'}}
            </label>
            <input id="file-upload" type="file" style="display: none" (change)="handleFileInput($event)"
                [disabled]="isDisabled" accept=".xls,.xlsx">

            <button type="button" class="btn btn-primary" [disabled]="isDisabled"
                (click)="ESS_EmpRoster_InsertUpdate()"><i class="bi bi-save2" *ngIf="!isDisabled"></i>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"
                    *ngIf="isDisabled"></span>
                {{!isDisabled?'Save':'Loading...'}}</button>
        </div>
    </div>
</div>